import CampaignDetailsPage from './CampaignDetailsPage';

export default CampaignDetailsPage;
